<template>
  <div>
    <MountingPortal mountTo="body" name="source" append>

    <div class="lightbox" v-if="lightBoxOpen" v-on:click.self="closeLightBox()">
      <button class="lightbox-close-button" v-on:click="closeLightBox()">
        <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0z" fill="none"/><path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/></svg>
      </button>
      <img class="lightbox-image" alt="" v-bind:src="this.url">
    </div>


      <transition name="fade">
        <div class="lightbox-shade"
             v-if="lightBoxOpen"
        ></div>
      </transition>
    </MountingPortal>
  </div>
</template>

<script>

import {MountingPortal} from "portal-vue";

export default {
  components: {
    MountingPortal,
  },
  mounted() {
    document.addEventListener('slaOpenLightBox', (event) => {
      this.lightBoxOpen = true;
      this.url = event.detail.url;
    });
  },
  methods: {
    closeLightBox() {
      this.lightBoxOpen = false;
      this.url = null;
    }
  },
  data: function () {
    return {
      lightBoxOpen: false,
      url: null,
    }
  }
}
</script>